//生日、周年路由
export default {
  path: "/anniversaryBirth",
  component: () => import('../view/kscircle/index.vue'),
  children: [{
    path: "BirthdayList", //生日主页面
    name: 'BirthdayList', //生日主页面
    component: () => import('../view/discovery/anniversaryBirth/BirthdayList.vue'), //生日主页面
    props: (route) => ({
      token: route.query.token,
      koaToken: route.query.koaToken,
      userId: route.query.userId,
      deviceType: route.query.deviceType,
      deviceName: route.query.deviceName,
      secondLoginType: route.query.secondLoginType,
      secondAssessToken: route.query.secondAssessToken,
      deviceId: route.query.deviceId,
    }),
    children: [{
      path: "BirthdayBlessing/:id/:birthday/:content/:photo/:index/:sex",
      name: "BirthdayDetail", // 生日详情页面
      component: () => import('../view/discovery/anniversaryBirth/BirthdayBlessing.vue'),
      props: (route) => ({
        token: route.query.token,
        koaToken: route.query.koaToken,
        userId: route.query.userId,
        deviceType: route.query.deviceType,
        deviceName: route.query.deviceName,
        secondLoginType: route.query.secondLoginType,
        secondAssessToken: route.query.secondAssessToken,
        deviceId: route.query.deviceId,
      })
    }]
  }, {
    path: "BlessingList", //周年主页面
    name: 'BlessingList', //周年主页面
    component: () => import('../view/discovery/anniversaryBirth/BlessingList.vue'), //周年主页面
    props: (route) => ({
      token: route.query.token,
      koaToken: route.query.koaToken,
      userId: route.query.userId,
      deviceType: route.query.deviceType,
      deviceName: route.query.deviceName,
      secondLoginType: route.query.secondLoginType,
      secondAssessToken: route.query.secondAssessToken,
      deviceId: route.query.deviceId,
    }),
    children: [{
      path: "AnniversaryBlessing/:id/:content/:index/:backgroundimage",
      name: "AnniversaryDetail", // 周年详情页面
      component: () => import('../view/discovery/anniversaryBirth/AnniversaryBlessing.vue'),
      props: (route) => ({
        token: route.query.token,
        koaToken: route.query.koaToken,
        userId: route.query.userId,
        deviceType: route.query.deviceType,
        deviceName: route.query.deviceName,
        secondLoginType: route.query.secondLoginType,
        secondAssessToken: route.query.secondAssessToken,
        deviceId: route.query.deviceId,
      })
    }],
  }]

}



// WEBPACK FOOTER //
// ./src/router/BirthAnniversaryRouter.js